module.exports = __webpack_public_path__ + "img/about_robot.214a0c3d.webp";